import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import API from "../../api/axios"
import DurationForm from "./DurationForm"
import { useNavigate } from "react-router-dom"
import { FaRegEyeSlash } from "react-icons/fa6"
import { setBreadcrumbItems } from "../../store/actions"

import { connect } from "react-redux"

import { isPropsEqual } from "@fullcalendar/core/internal"
const DurationTable = props => {
  console.log("DurationTable props:", props)
  const navigate = useNavigate()
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchDurations()
  }, [])

  const handleEditClick = duration => {
    console.log("patient id", duration)
    navigate(`/duration-profile/${duration.id}`, {
      state: { durationData: duration },
    })
  }

  const fetchDurations = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get("/duration", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      // refresh()
      setTableData(response.data)
      props.setBreadcrumbItems("Duration Table", breadcrumbItems)
    } catch (error) {
      console.error("Error fetching durations:", error)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Duration", link: "#" },
    // { title: "Data Tables", link: "#" },
  ]
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }
  const tableDataConfig = {
    columns: [
      {
        label: "Value (Minutes)",
        field: "value",
        searchable: true,
        sort: "asc",
        width: 150,
      },
      { label: "Created At", field: "createdAt", sort: "asc", width: 200 },
      { label: "Updated At", field: "updatedAt", sort: "asc", width: 200 },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],
    rows: tableData.map(duration => ({
      value: duration.value,
      createdAt: new Date(duration.createdAt).toLocaleString("en-In", options),
      updatedAt: new Date(duration.updatedAt).toLocaleString("en-In", options),
      action: (
        <button
          className="btn btn-success"
          onClick={() => handleEditClick(duration)}
        >
          <FaRegEyeSlash size={20} className="text-green-600" />
        </button>
      ),
    })),
  }

  return (
    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <CardTitle className="h4">Duration List</CardTitle>
            <DurationForm refresh={fetchDurations} />
            <MDBDataTable responsive bordered data={tableDataConfig} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default connect(null, { setBreadcrumbItems })(DurationTable)
